const StatCardStyles = (theme) => ({
    root: {
        width: '100%',
        flex: '1 1 auto',
        alignSelf: 'stretch',
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        cursor: 'pointer',
        height: 60,
        minHeight: 60,
        maxHeight: 60,
    },
    content: {
        position: 'relative',
        width: '100%',
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 1.5}px`,
        '&:last-child': {
            paddingBottom: theme.spacing.unit,
        },
    },
    title: {
        fontSize: '0.95rem',
        lineHeight: 1.2,
        display: '-webkit-box',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        wordBreak: 'break-word',
    },
    value: {
        flex: '0 0 auto',
        marginLeft: theme.spacing.unit,
        textAlign: 'right',
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    valueText: {
        display: 'inline-flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        fontSize: '1rem',
    },
    icon: {
        boxShadow: 'none',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        color: 'inherit',
    },
    iconFloat: {
        position: 'absolute',
        right: '15px',
        top: '50%',
        marginTop: '-20px',
        opacity: '0.2',
        transform: 'rotate(-5deg)',
    },
    lightText: {
        color: 'white',
    },
});

export default StatCardStyles;
